(function () {
  function slugify(text) {
    return String(text || "")
      .toLowerCase()
      .trim()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 80) || "section";
  }

  function uniqueId(base) {
    var id = base;
    var i = 2;
    while (document.getElementById(id)) {
      id = base + "-" + i;
      i += 1;
    }
    return id;
  }

  function buildToc(root) {
    var toc = root.querySelector("[data-mz-blog-toc]");
    var list = root.querySelector("[data-mz-blog-toc-list]");
    var content = root.querySelector("[data-mz-blog-content]");
    if (!toc || !list || !content) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll("h2, h3")).filter(function (heading) {
      return !heading.closest("[data-mz-toc-ignore]") && heading.textContent.trim().length > 0;
    });

    if (!headings.length) {
      toc.hidden = true;
      return;
    }

    list.innerHTML = "";
    headings.forEach(function (heading, index) {
      if (!heading.id) heading.id = uniqueId(slugify(heading.textContent));
      var item = document.createElement("li");
      var number = document.createElement("span");
      var link = document.createElement("a");
      number.className = "mz-blog-toc-number";
      number.textContent = String(index + 1).padStart(2, "0");
      link.href = "#" + heading.id;
      link.textContent = heading.textContent.trim();
      link.addEventListener("click", function (event) {
        event.preventDefault();
        var target = document.getElementById(heading.id);
        if (target) {
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - 90,
            behavior: "smooth"
          });
          history.replaceState(null, "", "#" + heading.id);
        }
      });
      item.appendChild(number);
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.hidden = false;
  }

  function wireFaq(root) {
    root.classList.add("mz-blog-js");
    var items = Array.prototype.slice.call(root.querySelectorAll("[data-mz-blog-faq-item]"));
    items.forEach(function (item, index) {
      var button = item.querySelector("[data-mz-blog-faq-question]");
      if (!button) return;
      if (index === 0) item.classList.add("is-open");
      button.setAttribute("aria-expanded", item.classList.contains("is-open") ? "true" : "false");
      button.addEventListener("click", function () {
        item.classList.toggle("is-open");
        button.setAttribute("aria-expanded", item.classList.contains("is-open") ? "true" : "false");
      });
    });
  }

  function wireChecklist(root) {
    Array.prototype.slice.call(root.querySelectorAll("[data-mz-blog-check]")).forEach(function (button) {
      button.addEventListener("click", function () {
        var item = button.closest("li");
        if (!item) return;
        item.classList.toggle("is-checked");
        button.setAttribute("aria-pressed", item.classList.contains("is-checked") ? "true" : "false");
      });
    });
  }

  function wireShare(root) {
    var share = root.querySelector("[data-mz-blog-share]");
    var copy = root.querySelector("[data-mz-blog-copy]");
    if (share) {
      share.addEventListener("click", function () {
        var payload = { title: document.title, url: window.location.href };
        if (navigator.share) {
          navigator.share(payload).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href).catch(function () {});
        }
      });
    }
    if (copy) {
      copy.addEventListener("click", function () {
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(window.location.href).then(function () {
          var original = copy.getAttribute("aria-label") || "Copy link";
          copy.setAttribute("aria-label", "Link copied");
          copy.setAttribute("title", "Link copied");
          window.setTimeout(function () {
            copy.setAttribute("aria-label", original);
            copy.setAttribute("title", original);
          }, 1600);
        }).catch(function () {});
      });
    }
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll("[data-mz-blog-root]")).forEach(function (root) {
      buildToc(root);
      wireFaq(root);
      wireChecklist(root);
      wireShare(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
